var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 812,
    height: 48,
    viewBox: "0 0 812 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1789",
    "data-name": "Groupe 1789",
    transform: "translate(15 -205)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    "data-name": "Ligne 2",
    x2: 763.572,
    transform: "translate(9.5 228.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1610",
    "data-name": "Groupe 1610",
    transform: "translate(-15 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    fill: "#f7c030",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks",
    "data-name": "Bienvenue sur Quicks",
    d: "M11.343,19V7.948H8.733V5.59h5.4V19Z",
    transform: "translate(12 11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1611",
    "data-name": "Groupe 1611",
    transform: "translate(112.117 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250",
    fill: "#e0df61",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1612",
    "data-name": "Groupe 1612",
    transform: "translate(239.234 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-3",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1613",
    "data-name": "Groupe 1613",
    transform: "translate(366.351 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-4",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1614",
    "data-name": "Groupe 1614",
    transform: "translate(492.171 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-5",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1615",
    "data-name": "Groupe 1615",
    transform: "translate(620.586 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-6",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1616",
    "data-name": "Groupe 1616",
    transform: "translate(749 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-7",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-2",
    "data-name": "Bienvenue sur Quicks",
    d: "M7.392,19V16.84l3.6-3.708q1.062-1.1,1.611-1.737a5.285,5.285,0,0,0,.756-1.071,1.949,1.949,0,0,0,.207-.846,1.472,1.472,0,0,0-.477-1.161,1.738,1.738,0,0,0-1.2-.423,2.163,2.163,0,0,0-1.314.423A2.435,2.435,0,0,0,9.732,9.6L7.3,8.812a3.883,3.883,0,0,1,.9-1.818A4.663,4.663,0,0,1,9.858,5.8a5.044,5.044,0,0,1,2.034-.423,5.5,5.5,0,0,1,2.34.468A3.68,3.68,0,0,1,15.8,7.156a3.513,3.513,0,0,1,.558,1.98,4.106,4.106,0,0,1-.252,1.413,5.811,5.811,0,0,1-.765,1.4,13.778,13.778,0,0,1-1.323,1.539L10.938,16.66h5.544V19Z",
    transform: "translate(124 216)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.20dc31efb2352a42a23083e130c38f59.svg";
export { ForwardRef as ReactComponent };